import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["aria-controls", "autoComplete", "Input"];
import { forwardRef } from 'react';
import { SearchInput } from '../SearchInput';
import styled from 'foundations-theming/utils';
import ShareInput from '../ShareInput/ShareInput';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledTypeaheadSearch = styled.div.withConfig({
  displayName: "TypeaheadSearch__StyledTypeaheadSearch",
  componentId: "sc-1pkpolp-0"
})(({
  theme
}) => {
  return {
    backgroundColor: theme.color['fill-tertiary-default'],
    borderTopLeftRadius: 'inherit',
    borderTopRightRadius: 'inherit',
    padding: theme.space['300'],
    position: 'relative',
    input: {
      paddingInlineEnd: theme.space['800'],
      backgroundColor: theme.color['fill-surface-default']
    }
  };
});
const TypeaheadSearchComponent = (_ref, ref) => {
  let {
      'aria-controls': ariaControls = 'off',
      autoComplete = 'off',
      Input = SearchInput
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(StyledTypeaheadSearch, {
    children: /*#__PURE__*/_jsx(Input, Object.assign({
      "aria-autocomplete": "list",
      "aria-controls": ariaControls,
      autoComplete: autoComplete,
      inputRef: ref,
      type: "search"
    }, rest))
  });
};
export const TypeaheadSearch = ShareInput( /*#__PURE__*/forwardRef(TypeaheadSearchComponent));
TypeaheadSearch.displayName = 'TypeaheadSearch';